import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Evaluate from './pages/Evaluate';
import Generate from './pages/Generate';
import RubricGrade from './pages/RubricGrade';
import Pricing from './pages/Pricing';
import Checkout from './pages/Checkout';
import History from './pages/History';
import Billing from './pages/Billing';
import Referrals from './pages/Referrals';
import { Terms, Privacy, Refund, Contact } from './pages/Legal';

function Protected({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-10 text-center text-ink-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return children;
}

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/dashboard"   element={<Protected><Dashboard /></Protected>} />
          <Route path="/evaluate"    element={<Protected><Evaluate /></Protected>} />
          <Route path="/generate"    element={<Protected><Generate /></Protected>} />
          <Route path="/rubric"      element={<Protected><RubricGrade /></Protected>} />
          <Route path="/checkout/:plan" element={<Protected><Checkout /></Protected>} />
          <Route path="/history"     element={<Protected><History /></Protected>} />
          <Route path="/billing"     element={<Protected><Billing /></Protected>} />
          <Route path="/referrals"   element={<Protected><Referrals /></Protected>} />
          {/* Legal / policy pages — public, linked from the footer. */}
          <Route path="/terms"       element={<Terms />} />
          <Route path="/privacy"     element={<Privacy />} />
          <Route path="/refund"      element={<Refund />} />
          <Route path="/contact"     element={<Contact />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
